import { isBillyCookBrandName } from "utils/index";

/** Approximate leather tones for Billy Cook saddle color names. */
const BILLY_COOK_COLOR_HEX = {
  russet: "#8B4513",
  "medium oil": "#6B4423",
  "hot oil": "#3D2817",
  chestnut: "#954535",
  chocolate: "#3B2F2F",
  "golden leather": "#C19A6B",
  black: "#1C1C1C",
};

export function getBillyCookColorHex(colorName) {
  const key = String(colorName ?? "").trim().toLowerCase();
  return BILLY_COOK_COLOR_HEX[key] || "#9CA3AF";
}

export function shouldShowBillyCookColorSwatches(brandName) {
  return isBillyCookBrandName(brandName);
}
